import { useCallback, useState } from 'react';

import { useIntl } from 'react-intl';

import { AppSwitcher as AppSwitcherTrigger } from '@atlaskit/navigation-system/top-nav-items';
import { Popup } from '@atlaskit/popup';
import { AtlassianSwitcherPrefetchTrigger } from '@atlassian/switcher';

import { BaseSwitcher as AppSwitcherContent } from 'src/components/navigation/src/components/atlassian-switcher/atlassian-switcher';
import { messages } from 'src/components/navigation/src/components/atlassian-switcher/atlassian-switcher.i18n';
import { RemoteSwitcherPreloader } from 'src/components/navigation/src/utils/use-remote-switcher-plugin';

export const TopNavAppSwitcher = (): JSX.Element => {
  const intl = useIntl();

  const [isOpen, setIsOpen] = useState(false);
  // Track if the trigger has *ever* been hovered in order to pre-load content
  // We shouldn't ever need to call `setHasHovered(false)`
  const [hasHovered, setHasHovered] = useState(false);

  const handleAppSwitcherClose = useCallback(() => setIsOpen(false), []);
  const handleTriggerClick = useCallback(() => {
    setIsOpen(prevState => !prevState);
  }, []);
  const handleTriggerHover = useCallback(() => {
    setHasHovered(true);
  }, []);

  return (
    <Popup
      content={() => <AppSwitcherContent appearance="standalone" />}
      isOpen={isOpen}
      onClose={handleAppSwitcherClose}
      placement="bottom-start"
      trigger={triggerProps => (
        <div>
          {hasHovered && <RemoteSwitcherPreloader />}
          <AtlassianSwitcherPrefetchTrigger product="bitbucket">
            <AppSwitcherTrigger
              {...triggerProps}
              interactionName="atlassian-switcher-open"
              isSelected={isOpen}
              label={intl.formatMessage(messages.tooltip)}
              onClick={handleTriggerClick}
              onMouseEnter={handleTriggerHover}
            />
          </AtlassianSwitcherPrefetchTrigger>
        </div>
      )}
    />
  );
};
